// Must match the backend rule in utils/tenantPassword.js (passwords are trimmed there too).
export const TENANT_PASSWORD_MIN_LENGTH = 10;

export const TENANT_PASSWORD_HINT = `At least ${TENANT_PASSWORD_MIN_LENGTH} characters. A short phrase is easiest to remember.`;

export function tenantPasswordError(password) {
  return String(password || '').trim().length < TENANT_PASSWORD_MIN_LENGTH
    ? `Password must be at least ${TENANT_PASSWORD_MIN_LENGTH} characters`
    : '';
}
